import * as ReactService from "@intech/react-service";
import { LGPDConsentimentoEntidade } from "../entidades/LGPDConsentimentoEntidade";

class LGPD extends ReactService.BaseService {
  constructor() {
    super("LGPD");
  }

  Buscar = () =>
    this.CreateRequest<LGPDConsentimentoEntidade[]>(ReactService.RequestType.GET, `Buscar`);

  Inserir = (origem: number) =>
    this.CreateRequest<string>(ReactService.RequestType.POST, `Inserir/${origem}`);

}

export const LGPDService = new LGPD();
